import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_COMPETENCE_TYPES } from '../actionConstants';

export const getAllCompetenceTypes = createAction(
  GET_DICTIONARIES_COMPETENCE_TYPES
);
